import { useRecoilValue } from 'recoil';

import { activeOrderIdState } from '../../atoms';
import { LiveOrder, LiveOrderStatusUpdate } from '../../types';
import { useOrder } from '../useOrder';
import { useAppSelector } from '../../../reduxstore/hooks';
export const useActiveOrder = (
	onUpdate?: LiveOrderStatusUpdate
): [id: string | undefined, liveOrder: LiveOrder] => {
	const activeOrderId = useRecoilValue(activeOrderIdState);
	const appUserIdFromRedux = useAppSelector(state => state.authReducer.id);

	const liveOrder = useOrder(
		activeOrderId ?? '',
		appUserIdFromRedux,
		onUpdate
	);

	return [activeOrderId, liveOrder];
};
